var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPrefilteringResultsFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 105,
    viewBox: "0 0 125 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_555_9637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.82 18.4702V11.5402C85.82 7.08021 82.21 3.47021 77.75 3.47021H10.82C6.36 3.47021 2.75 7.08021 2.75 11.5402V66.9302C2.75 71.3902 6.36 75.0002 10.82 75.0002H30.44",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.55 3.47021H115.24C119.38 3.47021 122.74 6.83021 122.74 10.9702C122.74 15.1102 119.38 18.4702 115.24 18.4702H102.55C98.41 18.4702 95.05 15.1102 95.05 10.9702C95.05 6.83021 98.41 3.47021 102.55 3.47021Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 84.2402H22.94C27.08 84.2402 30.44 87.6002 30.44 91.7402C30.44 95.8802 27.08 99.2402 22.94 99.2402H10.25C6.11 99.2402 2.75 95.8802 2.75 91.7402C2.75 87.6002 6.11 84.2402 10.25 84.2402Z",
    stroke: "#B8B5DD",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5599 65.0303C87.5799 55.8703 86.5699 43.4503 78.5099 35.3903C69.2999 26.1803 54.3599 26.1703 45.1399 35.3903C35.9299 44.6003 35.9299 59.5503 45.1399 68.7603C53.1999 76.8203 65.6299 77.8303 74.7799 71.8103",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8099 62.1C46.2799 56.56 46.2699 47.59 51.8099 42.05C57.3499 36.51 66.3199 36.51 71.8599 42.05",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9099 65.48L90.7799 74.35C91.9399 75.51 93.6199 75.71 94.5299 74.8C95.4399 73.89 97.1199 74.09 98.2799 75.25L111.62 88.59C112.78 89.75 112.98 91.43 112.07 92.34L107.76 96.65",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3201 75.52L85.4601 79.66C86.6201 80.83 86.8201 82.51 85.9201 83.41C85.4601 83.87 85.2901 84.51 85.3601 85.19C85.4401 85.87 85.7901 86.58 86.3701 87.16L99.7101 100.5C100.87 101.67 102.56 101.86 103.46 100.95L107.77 96.64",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_555_9637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.5,
    height: 103.06,
    fill: "white",
    transform: "translate(0.25 0.970215)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPrefilteringResultsFound);
export default __webpack_public_path__ + "static/media/no-prefiltering-results-found.961e8473ffcec629aa4e2b006be69d19.svg";
export { ForwardRef as ReactComponent };